{
  "nav": {
    "label": "Website content",
    "pages": "Pages",
    "policies": "Shop rules",
    "menus": "Menus",
    "redirects": "Address forwarding",
    "announcements": "Announcements",
    "translations": "Translations",
    "website_texts": "Website texts",
    "languages": "Languages",
    "media": "Pictures and files"
  },
  "common": {
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "edit": "Edit",
    "save": "Save",
    "saving": "Saving…",
    "loading": "Loading…",
    "load_more": "Show more",
    "japan_time": "Japan time (JST)"
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Could not reach the server. Check the internet connection and try again.",
    "forbidden": "Your account may not do this. Ask the owner for access.",
    "version_conflict": "Someone else saved this first.",
    "if_match_required": "Someone else changed this first — reload and try again",
    "handle_taken": "This web address is already used by another page.",
    "validation_failed": "Some values are not right. Check the highlighted boxes.",
    "page_not_found": "This page no longer exists.",
    "page_trashed": "This page is in the bin — restore it first.",
    "policy_incomplete": "Some required items are still empty.",
    "menu_in_use": "This menu is shown on the website. Remove it from the website design first.",
    "menu_depth_exceeded": "Menus can have at most 3 levels.",
    "menu_too_large": "This menu has too many items.",
    "redirect_exists": "There is already forwarding for this old address.",
    "redirect_invalid": "The old or new address is not right.",
    "redirect_loop": "This would send visitors around in a circle.",
    "redirect_chain_too_long": "Too many forwardings in a row — point the old address straight to the final page.",
    "announcement_limit_exceeded": "There are too many announcements. Delete old ones first.",
    "locale_required": "English (the main language) must stay on.",
    "translator_not_configured": "Automatic translation is not switched on yet.",
    "placeholder_mismatch": "A {name} in the text does not match the English text.",
    "icu_syntax_invalid": "The text has a { or } that is not closed.",
    "rate_limited": "Too many changes at once. Wait a moment and try again."
  },
  "unsaved": {
    "title": "Leave without saving?",
    "body": "Your changes on this screen are not saved yet.",
    "leave": "Leave and lose changes",
    "stay": "Stay here"
  },
  "locale": {
    "missing_sr": "(not translated yet)",
    "dots_label": "Languages",
    "tabs_for": "Languages of {{label}}",
    "english_required": "Write the English text — English is the main language of the website.",
    "state": {
      "missing": "not translated",
      "draft": "needs a check",
      "reviewed": "translated"
    }
  },
  "status": {
    "published": "On the website",
    "draft": "Draft",
    "scheduled": "Scheduled",
    "scheduled_at": "Goes live {{time}}",
    "trashed": "In the bin"
  },
  "preview": {
    "loading": "Preparing the preview…",
    "unavailable": "The preview cannot be shown right now (the website may not be running).",
    "open_new_tab": "Open the preview in a new tab"
  },
  "pages": {
    "title": "Pages",
    "intro": "Information pages such as About us, Contact or Rank standards.",
    "new": "New page",
    "search": "Search pages",
    "search_placeholder": "Name or web address",
    "filter": "Show",
    "filter_all": "All",
    "filter_published": "On the website",
    "filter_draft": "Drafts",
    "filter_scheduled": "Scheduled",
    "filter_trashed": "Bin",
    "empty": "No pages here yet.",
    "updated": "Changed {{time}}"
  },
  "page_editor": {
    "new_title": "New page",
    "create": "Create page",
    "preview": "Preview",
    "preview_frame": "Preview of the page (draft)",
    "languages": "Language",
    "side_by_side": "Compare 2 languages side by side",
    "side_hint": "Choose the language of each side. Both sides can be edited.",
    "side_left": "Left",
    "side_right": "Right",
    "title_label": "Page name ({{language}})",
    "body_label": "Text ({{language}})",
    "copy_from_en": "Copy from English",
    "copied": "Copied the English text into {{language}}. Please translate and check it.",
    "please_check": "Copied — please check",
    "visibility": "When it shows on the website",
    "mode_draft": "Keep as a draft (not on the website)",
    "mode_now": "Show on the website now",
    "mode_schedule": "Show at a time",
    "publish_now": "Show on the website now",
    "publish_at": "Date and time",
    "schedule": "Show at this time",
    "unpublish": "Take off the website",
    "cancel_schedule": "Cancel the scheduled time",
    "trash": "Move to the bin",
    "trash_title": "Move this page to the bin?",
    "trash_body": "It disappears from the website. You can bring it back from the bin later.",
    "restore": "Bring back from the bin",
    "restored": "The page is back (as a draft).",
    "published_ok": "The page is on the website now.",
    "scheduled_ok": "The page will go live at the time you chose.",
    "unpublished": "The page is no longer on the website.",
    "schedule_cancelled": "The scheduled time was cancelled. The page is a draft.",
    "created_draft": "Page created as a draft.",
    "created_now": "Page created and shown on the website.",
    "created_schedule": "Page created. It goes live at the time you chose.",
    "saved": "Saved.",
    "needs_english": "Write the English page name first — English is the main language of the website.",
    "when_invalid": "Choose a date and a time.",
    "settings": "Page settings",
    "handle": "Web address",
    "handle_hint": "Small letters, numbers and - only. Example: about-us",
    "handle_invalid": "Use small letters (a–z), numbers and - only, e.g. rank-standards.",
    "handle_taken": "Another page already uses this web address.",
    "handle_redirect": "When you save, visitors of the old address {{from}} are sent to the new one automatically.",
    "kind": "Kind of page",
    "kind_default": "General page",
    "kind_contact": "Contact page (with a message form)",
    "kind_help": "Help centre",
    "kind_faq": "Questions and answers",
    "kind_other": "Page style “{{name}}”",
    "seo": "Search engines",
    "seo_title": "Title in search results",
    "seo_description": "Description in search results",
    "chars": "{{count}} characters (about {{advice}} is best)",
    "google_sample": "How it can look on Google",
    "conflict": "Someone else saved this while you were editing.",
    "conflict_reload": "Load their version (my changes are lost)",
    "conflict_overwrite": "Keep my version",
    "warnings_title": "Some parts of the text were changed when saving:"
  },
  "content_warning": {
    "unsupported_node": "a part the website cannot show was turned into plain text",
    "unsupported_mark": "a text style the website cannot show was removed",
    "link_not_allowed": "a link that is not allowed was removed",
    "image_src_not_media": "a picture that is not from the picture library was removed — add it from the library",
    "embed_not_allowed": "a video that is not from YouTube or Vimeo was removed",
    "other": "something the website cannot show was removed"
  },
  "richtext": {
    "toolbar": "Text tools for {{label}}",
    "style": "Text style",
    "paragraph": "Normal text",
    "h2": "Big heading",
    "h3": "Heading",
    "h4": "Small heading",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "strike": "Crossed out",
    "bullet": "List with dots",
    "ordered": "Numbered list",
    "quote": "Quote",
    "link": "Link",
    "unlink": "Remove link",
    "image": "Picture",
    "image_pick": "Choose a picture",
    "image_placeholder": "Picture: {{name}}",
    "image_alt": "Description: {{alt}}",
    "image_no_alt": "No description yet — add one below",
    "image_alt_label": "Picture description (for people who cannot see it)",
    "image_alt_hint": "Say what is on the picture, e.g. “Pikachu card, Rank A, front side”.",
    "video": "YouTube / Vimeo video",
    "video_url": "Address of the video",
    "video_invalid": "Paste a YouTube or Vimeo address, e.g. https://www.youtube.com/watch?v=…",
    "embed_placeholder": "{{provider}} video ({{id}})",
    "table": "Table",
    "table_tools": "Table",
    "add_row": "Add row",
    "add_column": "Add column",
    "delete_row": "Remove row",
    "delete_column": "Remove column",
    "delete_table": "Remove table",
    "callout": "Note box",
    "callout_kind": "Kind of note",
    "callout_info": "Information",
    "callout_tip": "Tip",
    "callout_warning": "Warning",
    "callout_success": "Good news",
    "callout_note": "Note",
    "rule": "Line",
    "more": "More",
    "undo": "Undo",
    "redo": "Redo",
    "link_address": "Where the link goes",
    "link_invalid": "Use an address starting with https://, / (a page of the shop), mailto: or tel:.",
    "link_pick": "Or choose from the shop:",
    "pick_page": "Information page",
    "pick_policy": "Shop rules page",
    "pick_collection": "Category",
    "pick_product": "Product",
    "choose": "Choose…",
    "new_tab": "Open in a new tab",
    "apply": "Apply",
    "insert": "Insert",
    "paste_images_dropped": "Pictures pasted from other programs are not kept. Add them with the Picture button (picture library)."
  },
  "policies": {
    "title": "Shop rules",
    "intro": "Pages the law asks the shop to show. Each page says what is still missing before the shop opens.",
    "edit": "Open",
    "complete": "Complete",
    "missing_one": "{{count}} item missing ({{languages}})",
    "missing_other": "{{count}} items missing ({{languages}})",
    "published": "On the website (version {{version}}, {{time}})",
    "not_published": "Not on the website yet",
    "unpublished_changes": "Changes not on the website yet",
    "weight_law": "Required by law",
    "weight_recommended": "Recommended",
    "type": {
      "tokushoho": "Legal notice (特定商取引法に基づく表記)",
      "privacy": "Privacy policy",
      "terms": "Terms of service",
      "returns": "Returns (返品特約)",
      "shipping": "Shipping",
      "kobutsu": "Secondhand dealer notice (古物営業法)",
      "contact": "Contact"
    },
    "legal": {
      "tokushoho": "Online shops in Japan must show who sells, how to pay, delivery and the return rules.",
      "returns": "The law requires it on the website — without it customers may cancel within 8 days.",
      "privacy": "The privacy law (APPI) asks what the shop does with personal data, including data kept abroad.",
      "kobutsu": "A shop that buys and sells used goods shows its secondhand dealer licence on the website.",
      "terms": "The rules for using the website and buying.",
      "shipping": "How and where you ship, and what customers pay abroad.",
      "contact": "How customers can reach the shop."
    }
  },
  "policy_editor": {
    "unknown": "This page does not exist.",
    "save_draft": "Save draft",
    "saved": "Draft saved. It is not on the website until you publish it.",
    "preview": "Preview",
    "preview_frame": "Preview of the shop rules page (draft)",
    "shared_title": "Same in every language",
    "shared_hint": "Phone, e-mail, web address and licence numbers are written once for all languages.",
    "page_title": "Page name ({{language}})",
    "page_title_hint": "Leave empty to use the standard name.",
    "body": "Text ({{language}})",
    "body_name": "the text of the page",
    "locale_required": "{{language}} is required before publishing.",
    "locale_optional": "{{language}} is optional — empty items show the English text.",
    "required_in": "Required: {{languages}}",
    "example": "Example: {{example}}",
    "missing_in": "Still empty — fill it in {{language}} before publishing.",
    "missing_shared": "Still empty — fill it before publishing.",
    "missing_title": "Still missing:",
    "missing_item": "{{language}}: {{field}}",
    "incomplete": "Not published — some required items are empty. They are marked in red.",
    "publish_title": "Publish",
    "note": "Note for the history (optional)",
    "publish": "Publish shop rules",
    "publish_hint": "Japanese and English must be complete. Other languages only show a reminder.",
    "publish_needs_manager": "Only the owner or a manager can publish. Save the draft and tell them.",
    "published": "Published (version {{version}}).",
    "published_with_gaps": "Published (version {{version}}). Not translated yet: {{languages}} — those visitors see English.",
    "nothing_new": "Nothing new to publish — the website already shows this.",
    "suggest_payments": "Take payment methods from the payment settings",
    "suggested": "Filled in from the payment settings. Please check the wording.",
    "suggest_unavailable": "The payment settings cannot be read right now. Write the payment methods by hand.",
    "checklist_title": "Required items",
    "checklist_appi": "What the privacy law (APPI) asks for",
    "versions": "Published versions",
    "version_line": "Version {{version}} · {{time}}",
    "no_versions": "Not published yet.",
    "placeholder": "This is still sample wording in [[ ]] — replace it with the shop's real information."
  },
  "policy_fields": {
    "business_name": {
      "label": "Seller (shop or company name)",
      "hint": "The name of the business that sells — as registered.",
      "example": "株式会社〇〇 / TCG Shop Tokyo"
    },
    "representative": {
      "label": "Person in charge",
      "hint": "The representative or the person responsible for the online shop.",
      "example": "山田 太郎"
    },
    "address": {
      "label": "Address",
      "hint": "Where the business is — the full address.",
      "example": "〒150-0001 東京都渋谷区…"
    },
    "phone": {
      "label": "Phone",
      "hint": "A number customers can call.",
      "example": "+81-3-1234-5678"
    },
    "phone_hours": {
      "label": "Phone hours",
      "hint": "When the phone is answered.",
      "example": "10:00–18:00 (closed on Wednesdays)"
    },
    "email": {
      "label": "E-mail",
      "hint": "The address for questions about orders.",
      "example": "support@example.com"
    },
    "url": {
      "label": "Website",
      "hint": "The address of this online shop.",
      "example": "https://shop.example.com"
    },
    "price_display": {
      "label": "Prices",
      "hint": "Say that prices include consumption tax and where they are shown.",
      "example": "Shown on each product page (tax included)"
    },
    "additional_fees": {
      "label": "Other costs",
      "hint": "Shipping, bank transfer fees, import duties abroad.",
      "example": "Shipping from ¥…; bank transfer fees are paid by the customer"
    },
    "payment_methods": {
      "label": "Payment methods",
      "hint": "Every way customers can pay — or use the button below.",
      "example": "Bank transfer, pay in store"
    },
    "payment_timing": {
      "label": "When to pay",
      "hint": "Until when the customer must pay.",
      "example": "Within 3 days after the order"
    },
    "delivery_timing": {
      "label": "Delivery time",
      "hint": "When the goods are sent after payment.",
      "example": "Sent within 2 business days after payment"
    },
    "return_policy": {
      "label": "Returns and exchanges",
      "hint": "Your return rules (返品特約). Without them customers may cancel within 8 days.",
      "example": "Because of the nature of trading cards, returns are not accepted except…"
    },
    "quantity_limit": {
      "label": "Quantity limits",
      "hint": "If a customer may only buy a certain number.",
      "example": "Most cards are one of a kind"
    },
    "application_validity": {
      "label": "Order validity / cancellation",
      "hint": "How long an unpaid order is kept.",
      "example": "Orders not paid within 3 days are cancelled"
    },
    "kobutsu_license": {
      "label": "Secondhand dealer licence",
      "hint": "Leave empty to use the one from the secondhand dealer notice page.",
      "example": "東京都公安委員会 第123456789012号"
    },
    "other_notes": {
      "label": "Other notes",
      "hint": "Anything else customers should know.",
      "example": ""
    },
    "controller_name": {
      "label": "Business name",
      "hint": "Who is responsible for the personal data.",
      "example": ""
    },
    "controller_address": {
      "label": "Address",
      "hint": "",
      "example": ""
    },
    "purposes": {
      "label": "Why data is used",
      "hint": "E.g. to send orders, answer questions, confirm identity for buying cards.",
      "example": ""
    },
    "disclosure_procedure": {
      "label": "How to ask to see, correct or delete data",
      "hint": "Where and how customers ask.",
      "example": ""
    },
    "security_measures": {
      "label": "How data is protected",
      "hint": "Include the countries where data is kept (e.g. payment in the USA).",
      "example": ""
    },
    "foreign_transfer": {
      "label": "Data sent abroad",
      "hint": "Which companies abroad receive data, and the country.",
      "example": ""
    },
    "complaints_contact": {
      "label": "Where to complain",
      "hint": "The contact for complaints about personal data.",
      "example": ""
    },
    "final_sale_summary": {
      "label": "Return rules in one line",
      "hint": "Shown on the product page and before the customer orders.",
      "example": "Returns only for items that differ from the description"
    },
    "licensee_name": {
      "label": "Licence holder",
      "hint": "The name on the secondhand dealer licence.",
      "example": ""
    },
    "commission_name": {
      "label": "Public Safety Commission",
      "hint": "The commission that gave the licence.",
      "example": "東京都公安委員会"
    },
    "license_number": {
      "label": "Licence number",
      "hint": "The number on the licence.",
      "example": "第123456789012号"
    },
    "notified_url": {
      "label": "Registered website",
      "hint": "The website address you told the police about.",
      "example": "https://shop.example.com"
    },
    "hours": {
      "label": "Opening hours",
      "hint": "",
      "example": "11:00–20:00"
    },
    "line_url": {
      "label": "LINE",
      "hint": "The LINE address of the shop, if you have one.",
      "example": ""
    }
  },
  "menus": {
    "title": "Menus",
    "intro": "The menus at the top and bottom of the website.",
    "editor_intro": "Choose an item to change it. Drag, or use the arrows, to move items (up to 3 levels).",
    "item_count_one": "{{count}} item",
    "item_count_other": "{{count}} items",
    "new_name": "Name of a new menu",
    "new_placeholder": "e.g. Footer — shop",
    "create": "Create menu",
    "items": "Menu items",
    "add": "Add item",
    "empty": "No items yet — add the first one.",
    "keyboard_hint": "Keyboard: Alt + ↑ / ↓ moves, Alt + → puts it under the item above, Alt + ← takes it out.",
    "tree_label": "Menu items",
    "children_of": "Items under {{name}}",
    "no_label": "(no name yet)",
    "drag": "Drag to move {{name}}",
    "up": "Move up",
    "down": "Move down",
    "indent": "Put under the item above",
    "outdent": "Take out one level",
    "add_child": "Add an item under this one",
    "duplicate": "Make a copy",
    "remove": "Remove",
    "item_form": "Menu item",
    "pick_item": "Choose a menu item on the left to change it.",
    "label": "Name",
    "link": "Goes to",
    "badge": "Small label",
    "badge_hint": "Optional, e.g. NEW or SALE.",
    "image": "Picture (for the large menu)",
    "image_hint": "Optional — shown in the large drop-down menu and on phones.",
    "image_pick": "Choose a picture",
    "image_change": "Change picture",
    "image_remove": "Remove picture",
    "new_tab": "Open in a new tab",
    "menu_name": "Menu name",
    "handle": "Used on the website as “{{handle}}”.",
    "saved": "Menu saved. The website shows it within a few seconds.",
    "problem_label": "the English name is missing",
    "fix_first_one": "{{count}} item needs attention before saving.",
    "fix_first_other": "{{count}} items need attention before saving.",
    "too_many": "A menu can have at most {{max}} items.",
    "delete": "Delete menu",
    "delete_title": "Delete this menu?",
    "delete_body": "The menu and all its items are removed.",
    "in_use": "This menu is shown on the website. Choose another menu in the website design first.",
    "issues_title": "Please check:",
    "ref_issue": {
      "not_found": "“{{target}}” does not exist any more.",
      "unpublished": "“{{target}}” is not on the website — the item is hidden.",
      "deleted": "“{{target}}” was deleted.",
      "handle_changed": "“{{target}}” has a new web address."
    },
    "warning": {
      "other": "An item links to something that may not work."
    },
    "preview": "The website with this menu",
    "preview_hint": "Shows the saved menu. Save to see your changes here.",
    "preview_frame": "Website preview with the menu"
  },
  "link": {
    "kind": "Kind of link",
    "target_collection": "A category",
    "target_filtered": "A category with a filter (e.g. only Rank A)",
    "target_product": "A product",
    "target_page": "An information page",
    "target_policy": "A shop rules page",
    "target_search": "A search",
    "target_url": "Another address",
    "target_none": "No link (heading only)",
    "pick_collection": "Choose a category",
    "pick_product": "Choose a product",
    "pick_page": "Choose a page",
    "pick_policy": "Choose a shop rules page",
    "filter_rank": "Card condition (Rank)",
    "rank": "Rank {{rank}}",
    "filter_type": "Kind of product",
    "type_any": "All kinds",
    "type_raw_single": "Single cards (raw)",
    "type_graded_single": "Graded cards",
    "type_sealed_product": "Sealed products",
    "search_words": "Search words",
    "search_placeholder": "e.g. pikachu",
    "address": "Address",
    "goes_to": "Goes to: {{path}}",
    "problem_missing_target": "Choose where the link goes.",
    "problem_url_invalid": "Use an address starting with https:// or / (a page of the shop)."
  },
  "redirects": {
    "title": "Address forwarding",
    "intro": "When a web address changes, visitors of the old address are sent to the new one.",
    "tab_redirects": "Forwarding",
    "tab_not_found": "Addresses not found",
    "search": "Search",
    "source": "Made by",
    "source_all": "Everyone",
    "source_manual": "Added by hand",
    "source_auto": "Automatic",
    "source_import": "From a file",
    "add": "Add forwarding",
    "add_title": "New forwarding",
    "edit_title": "Change forwarding",
    "import": "Import from a file",
    "export": "Download as a file",
    "from": "Old address",
    "to": "New address",
    "from_hint": "Without the language, e.g. /products/old-card",
    "to_hint": "A page of the shop (/collections/pokemon) or https://…",
    "kind": "Kind",
    "kind_301": "Moved for good (recommended)",
    "kind_302": "Only for a while",
    "hits": "Used",
    "actions": "Actions",
    "pick": "Choose",
    "pick_row": "Choose {{from}}",
    "off": "Switched off",
    "switch_off": "Switch off",
    "switch_on": "Switch on",
    "created": "Forwarding added.",
    "updated": "Forwarding changed.",
    "count_one": "{{count}} forwarding",
    "count_other": "{{count}} forwardings",
    "empty": "No forwarding yet.",
    "delete_picked": "Delete {{count}} chosen",
    "delete_title_one": "Delete {{count}} forwarding?",
    "delete_title_other": "Delete {{count}} forwardings?",
    "delete_body": "Visitors of the old addresses will see “page not found”.",
    "deleted_one": "{{count}} forwarding deleted.",
    "deleted_other": "{{count}} forwardings deleted.",
    "import_title": "Import forwarding from a file",
    "import_intro": "A CSV file with the columns from,to (and status). The file is checked first — nothing is saved until you confirm.",
    "import_file": "Choose a file",
    "import_paste": "…or paste the content",
    "import_check": "Check the file",
    "checking": "Checking…",
    "import_back": "Choose another file",
    "import_confirm_one": "Import {{count}} row",
    "import_confirm_other": "Import {{count}} rows",
    "import_summary": "{{total}} rows: {{valid}} can be imported, {{errors}} have a problem and will be skipped.",
    "import_running": "Importing… {{done}} of {{total}}",
    "import_errors_one": "{{count}} row with a problem",
    "import_errors_other": "{{count}} rows with a problem",
    "import_failed": "The import stopped. Nothing was changed. Please try again.",
    "imported": "Imported: {{created}} new, {{updated}} changed, {{skipped}} skipped.",
    "row": "Row",
    "problem": "Problem",
    "code": {
      "from_invalid": "The old address is not right — it must start with /.",
      "locale_prefix": "Leave out the language at the start (/ja/…).",
      "system_route": "This address belongs to the shop system and cannot be forwarded.",
      "to_invalid": "The new address is not right.",
      "status_invalid": "The kind must be 301 or 302.",
      "duplicate_in_file": "This old address appears twice in the file.",
      "redirect_loop": "This would send visitors around in a circle.",
      "redirect_chain_too_long": "Too many forwardings in a row.",
      "self_redirect": "The old and new addresses are the same.",
      "other": "This row cannot be imported."
    },
    "not_found_intro": "Addresses customers opened that do not exist. Send them somewhere useful.",
    "not_found_empty": "No missing addresses — well done.",
    "not_found_count_one": "Opened {{count}} time · last {{time}}",
    "not_found_count_other": "Opened {{count}} times · last {{time}}",
    "create_for": "Forward this address",
    "dismiss": "Hide"
  },
  "announcements": {
    "title": "Announcements",
    "intro": "Short messages in the bar at the top of the website.",
    "add": "New announcement",
    "add_title": "New announcement",
    "edit_title": "Change announcement",
    "empty": "No announcements yet.",
    "created": "Announcement added.",
    "saved": "Announcement saved.",
    "conflict": "Someone else changed this announcement. Close and open it again.",
    "text": "Message",
    "text_hint": "Up to 200 characters.",
    "text_required": "Write the message.",
    "link": "When clicked, go to",
    "starts": "Starts",
    "starts_hint": "Japan time. Empty = now.",
    "ends": "Ends",
    "ends_hint": "Japan time. Empty = until you switch it off.",
    "ends_before_starts": "The end must be after the start.",
    "languages": "Shown in",
    "all_languages": "every language",
    "only_languages": "only {{languages}}",
    "markets": "Shown to customers in",
    "all_markets": "every country",
    "only_markets": "only {{markets}}",
    "market_JP": "Japan",
    "market_US": "USA",
    "market_EU": "Europe",
    "market_UK": "UK",
    "market_TW": "Taiwan",
    "market_HK": "Hong Kong",
    "market_SG": "Singapore",
    "market_TH": "Thailand",
    "market_ROW": "Other countries",
    "colors": "Colours",
    "colors_default": "Standard colours of the bar",
    "scheme": "Colour set {{n}}",
    "active": "Switched on",
    "on": "On",
    "off": "Off",
    "switch": "Show “{{text}}”",
    "state_live": "Showing now",
    "state_live_until": "Showing now · until {{time}}",
    "state_scheduled": "Scheduled",
    "state_scheduled_at": "Shows {{time}}",
    "state_ended": "Ended",
    "state_inactive": "Switched off",
    "sample": "Sample of the bar",
    "sample_language": "Language of the sample",
    "sample_empty": "Your message appears here",
    "preview_site": "See it on the website (saved announcements)",
    "preview_frame": "Website preview with the announcement bar",
    "delete_title": "Delete this announcement?",
    "delete_body": "It disappears from the website."
  },
  "translations": {
    "title": "Translations",
    "intro": "Every text of the website in every language. Filter what is not translated yet and fill it in.",
    "progress": "Translated per language",
    "progress_of": "Translated into {{language}}",
    "progress_text": "{{translated}} of {{total}} · {{missing}} missing",
    "language": "Language",
    "kind": "What",
    "kind_all": "Everything",
    "kind_page": "Pages",
    "kind_policy": "Shop rules",
    "kind_menu": "Menus",
    "kind_announcement": "Announcements",
    "kind_theme": "Website design texts",
    "kind_ui_strings": "Website texts (buttons, labels)",
    "kind_media": "Picture descriptions",
    "search": "Search",
    "missing_only": "Only not translated",
    "copied_only": "Only copied / needs a check",
    "save_one": "Save {{count}} change",
    "save_other": "Save {{count}} changes",
    "suggest_one": "Translate {{count}} chosen automatically",
    "suggest_other": "Translate {{count}} chosen automatically",
    "suggested": "{{count}} suggestions filled in — please check them before saving.",
    "mt_off": "Automatic translation is not switched on yet. Please translate by hand.",
    "export_csv": "Download CSV",
    "export_json": "Download JSON",
    "import": "Upload CSV",
    "import_ready": "File ready.",
    "import_check": "Check the file",
    "import_summary": "{{total}} rows: {{changed}} would change, {{unchanged}} are the same, {{skipped}} have a problem.",
    "import_row": "Row {{row}}: ",
    "import_confirm_one": "Save {{count}} change",
    "import_confirm_other": "Save {{count}} changes",
    "imported": "Imported: {{changed}} changed, {{skipped}} skipped.",
    "saved_one": "{{count}} translation saved.",
    "saved_other": "{{count}} translations saved.",
    "saved_publish_one": "{{count}} translation saved. {{policies}} shop rules page must be published to show it.",
    "saved_publish_other": "{{count}} translations saved. {{policies}} shop rules pages must be published to show them.",
    "count_one": "{{count}} text shown · {{missing}} not translated into {{language}}",
    "count_other": "{{count}} texts shown · {{missing}} not translated into {{language}}",
    "all_done": "Everything is translated.",
    "empty": "Nothing found.",
    "table_label": "Texts in {{language}}",
    "col_what": "Where",
    "col_english": "English",
    "pick_row": "Choose {{what}}",
    "edit_label": "{{what}} in {{language}}",
    "status_missing": "Not translated",
    "status_draft": "Needs a check",
    "status_reviewed": "Translated",
    "copy_en": "Copy English",
    "rich_has": "Formatted text — translated",
    "rich_missing": "Formatted text — not translated",
    "rich_edit": "Edit on its own screen",
    "website_texts_link": "Website texts (buttons, labels) →",
    "resource": {
      "page": "Page",
      "policy": "Shop rules",
      "menu": "Menu",
      "announcement": "Announcement",
      "template": "Website design",
      "section_group": "Website design",
      "ui_strings": "Website text",
      "media": "Picture"
    },
    "import_error": {}
  },
  "ui_strings": {
    "title": "Website texts",
    "intro": "Buttons, labels and messages of the website. Words in { } are filled in by the website — keep them as in English.",
    "groups": "Groups of texts",
    "search": "Search by key or text",
    "count_one": "{{count}} text",
    "count_other": "{{count}} texts",
    "empty": "No texts found.",
    "table_label": "Website texts in {{language}}",
    "edit_label": "{{key}} in {{language}}",
    "core": "Built-in",
    "saved_one": "{{count}} text saved.",
    "saved_other": "{{count}} texts saved.",
    "fix_first_one": "Fix {{count}} text marked in red before saving.",
    "fix_first_other": "Fix {{count}} texts marked in red before saving.",
    "unknown_placeholder": "{{names}} is not in the English text — the website would show it as it is.",
    "missing_placeholder": "{{names}} of the English text is left out.",
    "icu": {
      "unclosed": "A { is not closed with }.",
      "unopened": "A } has no { — put '}' in quotes to show it.",
      "double_braces": "Put one pair of { } around the name, not two.",
      "name_expected": "A name is expected after {.",
      "format_expected": "A format (number, date, plural …) is expected after the comma.",
      "unknown_format": "“{{detail}}” is not a known format.",
      "choice_unsupported": "“choice” is not supported — use plural or select.",
      "plural_choice": "“{{detail}}” is not a plural choice (zero, one, two, few, many, other or =N).",
      "choice_expected": "A choice ({…}) is expected.",
      "choice_twice": "The choice “{{detail}}” appears twice.",
      "other_required": "The choice “other” is required.",
      "too_deep": "The text is nested too deeply.",
      "unexpected": "“{{detail}}” is not expected here.",
      "brace_in_style": "{ is not allowed in a format."
    },
    "problem": {
      "placeholder_mismatch": "The words in { } do not match the English text.",
      "placeholder_missing": "A word in { } of the English text is left out.",
      "icu_syntax_invalid": "The text has a { or } problem.",
      "translations_outdated": "The English text changed — check the translations."
    },
    "ns": {
      "common": "General",
      "header": "Top of the website",
      "footer": "Bottom of the website",
      "home": "Home page",
      "product": "Product page",
      "rank": "Card Rank A–D",
      "collection": "Category page",
      "filters": "Filters",
      "search": "Search",
      "cart": "Cart",
      "checkout": "Checkout",
      "payment": "Payment",
      "tracking": "Order tracking",
      "account": "Customer account",
      "policies": "Shop rules",
      "errors": "Error messages",
      "a11y": "For screen readers",
      "seo": "Search engines"
    }
  },
  "languages": {
    "title": "Languages",
    "intro": "Which languages the website shows, and how visitors get their language.",
    "list": "Website languages",
    "needs_manager": "Only the owner or a manager can change languages — the website changes at once.",
    "default": "Main language",
    "on": "On",
    "off": "Off",
    "shown": "Shown on the website",
    "hidden": "Not shown",
    "switch": "Show {{language}} on the website",
    "default_locked": "Always on — it is the main language.",
    "translated": "{{percent}}% translated",
    "go_translate": "Translate what is missing",
    "turned_on": "{{language}} is on the website now.",
    "turned_off": "{{language}} is no longer shown.",
    "off_title": "Stop showing {{language}}?",
    "off_body": "Visitors are no longer sent to {{language}} and search engines stop showing it. The texts stay saved — you can switch it on again.",
    "off_confirm": "Stop showing",
    "default_title": "Main language",
    "default_value": "{{language}} (fixed)",
    "default_reason": "The main language stays English: the website addresses without a language and search engines depend on it. Other languages show English where they are not translated.",
    "detection_title": "The first visit",
    "detection_intro": "What happens when someone opens the website for the first time:",
    "mode_auto_redirect": "Open the visitor's language automatically",
    "mode_auto_redirect_effect": "A visitor from Japan is taken to the Japanese pages the first time. Their choice is remembered.",
    "mode_banner": "Suggest the visitor's language",
    "mode_banner_effect": "The page stays in English, with a small bar “View this page in 日本語?”.",
    "mode_off": "Do nothing",
    "mode_off_effect": "Everyone sees the address they opened; they can change the language themselves.",
    "mode_saved": "Saved. The website uses it for new visitors.",
    "conflict": "Someone else changed the languages at the same time. The screen shows the newest settings — please try again."
  },
  "media": {
    "title": "Pictures and files",
    "intro": "Every picture of the website in one place. Upload from your computer or phone, add a short description, and see where each picture is used.",
    "focal_label": "Part of the picture to keep in view",
    "focal_value": "{{x}} from the left, {{y}} from the top",
    "focal_set": "When the picture is cut to fit, this point stays in view.",
    "focal_hint": "Tap the most important part of the picture (for example the card) so it stays in view when the picture is cut to fit.",
    "focal_clear": "Use the middle again",
    "folder": "Folder",
    "folders": "Folders",
    "all_files": "All pictures and files",
    "folder_name_needed": "Type a name for the folder.",
    "folder_name_taken": "A folder with this name is already here.",
    "folder_failed": "The folder could not be changed. Please try again.",
    "folder_too_deep": "Folders can go 5 levels deep at most.",
    "folder_new": "New folder",
    "folder_rename": "Rename",
    "folder_delete": "Remove folder",
    "folder_new_inside": "Name of the new folder inside \"{{name}}\"",
    "folder_new_top": "Name of the new folder",
    "folder_rename_label": "New name of the folder",
    "folder_top": "(no folder)",
    "folder_deleted_one": "Folder removed. {{count}} picture moved up one level.",
    "folder_deleted_other": "Folder removed. {{count}} pictures moved up one level.",
    "folder_has_folders": "Remove the folders inside it first.",
    "folder_delete_title": "Remove this folder?",
    "folder_delete_body": "The pictures in it are not removed — they move up one level.",
    "detail_failed": "The details of this picture could not be loaded.",
    "saved": "Saved.",
    "save_media_down": "The picture service is not answering, so nothing was saved. Please try again in a minute.",
    "save_forbidden": "You are not allowed to change pictures. Ask a manager.",
    "save_failed": "Could not save. Please try again.",
    "remove_failed": "The picture could not be removed. Please try again.",
    "untitled": "Picture without a name",
    "detail_close": "Close the details",
    "open_file": "Open the file",
    "alt_title": "Description of the picture",
    "alt_hint": "A few words about what the picture shows. Search engines and people who cannot see the picture read it.",
    "alt_missing_en": "This picture has no English description yet — it is needed before the picture is used on the website.",
    "alt_missing": "Still empty: {{languages}}.",
    "alt_needed": "needed",
    "alt_placeholder": "e.g. Umbreon VMAX card, front",
    "tags": "Tags",
    "tag_remove": "Remove tag {{tag}}",
    "tags_placeholder": "Type a tag and press Enter",
    "save": "Save changes",
    "discard": "Undo my changes",
    "used_where": "Used on",
    "used_nowhere": "Not used anywhere yet.",
    "in_use_title": "This picture is still on the website",
    "in_use_body": "Change these places to another picture first, then remove it:",
    "remove": "Remove picture",
    "remove_title": "Remove this picture from the list?",
    "remove_body": "It is hidden from the list. Pictures still used on the website cannot be removed.",
    "use_template": "Website design — page \"{{page}}\"",
    "use_group": "Website design — {{area}}",
    "use_settings": "Website design — logo / icon",
    "use_page": "Page \"{{name}}\"",
    "use_policy": "Shop rules — {{name}}",
    "use_menu": "Menu \"{{name}}\"",
    "use_live": "on the website",
    "use_draft": "draft only",
    "search": "Search pictures",
    "search_placeholder": "Name, description or tag",
    "tag": "Tag",
    "tag_any": "All tags",
    "kind": "Type",
    "kind_any": "Everything",
    "kind_image": "Pictures",
    "kind_video": "Videos",
    "kind_file": "Files (PDF)",
    "upload": "Upload pictures",
    "upload_files": "Upload files",
    "camera": "Take a photo",
    "upload_rules": "JPEG, PNG, WebP, GIF or HEIC (iPhone), up to 25 MB each. You can also drag pictures here.",
    "upload_rules_file": "Pictures up to 25 MB or PDF up to 20 MB. You can also drag files here.",
    "video_links": "Videos are added as a YouTube or Vimeo link in the part itself.",
    "list_failed": "The pictures could not be loaded.",
    "retry": "Try again",
    "none_found": "Nothing found for \"{{q}}\".",
    "empty": "No pictures here yet. Upload the first one.",
    "count_one": "{{count}} picture",
    "count_other": "{{count}} pictures",
    "results": "Pictures",
    "detail": "Picture details",
    "no_alt_badge": "No description",
    "picked": "chosen",
    "uploads": "Uploads",
    "uploads_busy_one": "Uploading {{count}} file…",
    "uploads_busy_other": "Uploading {{count}} files…",
    "uploads_done_one": "{{count}} file uploaded.",
    "uploads_done_other": "{{count}} files uploaded.",
    "uploads_clear": "Clear the list",
    "problem": {
      "type": "This kind of file is not accepted. Use JPEG, PNG, WebP, GIF or HEIC.",
      "too_large": "The file is too large (pictures up to 25 MB).",
      "empty": "The file is empty.",
      "network_error": "The connection dropped. Check the internet and try again.",
      "processing_timeout": "The picture is taking long to prepare. It will appear by itself, or try again.",
      "mime_mismatch": "The file is not the kind of file its name says.",
      "unsupported_media_type": "This kind of file is not accepted.",
      "size_mismatch": "The file did not arrive completely. Try again.",
      "corrupt_file": "The file is damaged and cannot be opened.",
      "processing_failed": "The picture could not be prepared. Upload it again.",
      "pdf_invalid": "The PDF cannot be opened.",
      "file_too_large": "The file is too large.",
      "upload_quota_exceeded": "Too many uploads at once. Wait a minute and try again.",
      "upload_not_received": "The file did not arrive. Try again.",
      "purpose_not_allowed": "This kind of file cannot be uploaded here.",
      "forbidden": "You are not allowed to upload. Ask a manager.",
      "other": "The file could not be uploaded."
    },
    "upload_status": {
      "waiting": "Waiting",
      "uploading": "Uploading",
      "processing": "Preparing",
      "ready": "Done",
      "failed": "Not sent",
      "rejected": "Not accepted",
      "cancelled": "Stopped"
    },
    "upload_cancel": "Stop uploading {{name}}",
    "upload_progress": "Upload of {{name}}",
    "picker_hint": "Choose a picture, or upload a new one. Tap it, then press \"Use this picture\".",
    "picker_hint_many": "Choose one or more pictures, or upload new ones.",
    "picked_count_one": "{{count}} chosen",
    "picked_count_other": "{{count}} chosen",
    "use_many_one": "Use {{count}} picture",
    "use_many_other": "Use {{count}} pictures",
    "use_picture": "Use this picture",
    "use_file": "Use this file",
    "alt_off": "language not switched on yet"
  }
}
